import React from "react";
import { HashRouter, Route, Routes, Navigate } from "react-router-dom";
import Landing from "./pages/landing/landing.js";
import { connect } from "react-redux";
import SecondLayerAuth from "./pages/Login/secondLayerAuth.js";
import Static from "./pages/Login/static.js";
import LogoutPage from "./pages/Login/logoutPage.js";
import RevealSessionExpiredPage from "./pages/Login/revealSessionExpiredPage.js";
import SomethingWentWrong from "./pages/Login/somethingWentWrong";
import AccessDenied from "./pages/Login/accessDenied";
import InactiveAccount from "./pages/Login/InactiveAccount.js";
import FailedToAccessAccount from "./pages/Login/failedToAccessAccount.js";
import MetricDashboardPage from "./pages/MetricDashboard/MetricDashboardPage";
import { isNonERPCountryAccount, NON_ERP_UNAUTHORIZED_MODULES } from "./util/nonERPCountryUtils";
import IdleTimerContainer from "./pages/Login/IdleTimerContainer";
import { REDBALL_INACTIVE_ACCOUNT_CONSTANTS } from "./constants/StringConstants";

function Pages(_props) {
  function ProtectedRoute(validate) {

    if (
      validate.isAuthenticated ||
      validate.sessionExpired ||
      validate.logout ||
      validate.revealSessionExpired ||
      validate.SomethingWentWrong ||
      validate.accessDenied ||
      validate.inactiveAccount ||
      validate.failedToAccessAccount
    ) {
      if (isNonERPCountryAccount(_props.contractAccountCountry)) return routerGuard(validate);
      else return validate.children;
    } else if (!validate.isPermitted) {
      return <Navigate to="/accessDenied"></Navigate>;
    } else if (_props.activeCookie === true) {
      return <Navigate to="/login"></Navigate>;
    } else {
      return <Navigate to="/login"></Navigate>;
    }
  }
  function routerGuard(validate) {
    //If country is ERP country then allow children
    if (isNonERPCountryAccount(_props.contractAccountCountry) && validate?.module && NON_ERP_UNAUTHORIZED_MODULES.includes(validate.module)) {
      //if country is non erp country and user tried un-authorized route then redirect to accessDenied
      return <Navigate to="/accessDenied"></Navigate>;
    } else {
      return validate.children;
    }
  }
  /*Allow users to access Technician appointment page based on below conditions
  1. User has admin access
  2. Region belongs to US
  3. For non-government: always allowed
  4. For government: only Sourcewell brand allowed
  */

  // Use the centralized access logic from Redux state
  const technicianAppointmentValidAccess = _props.technicianAppointmentValidAccess;

  return (
    <HashRouter>
      <IdleTimerContainer />
      <Routes>
        <Route
          path="/account/myProfile/primaryAccount"
          element={
            <ProtectedRoute isAuthenticated={_props.isAuthenticated && _props.accountProfilePermission} isPermitted={_props.accountProfilePermission}>
              <Landing activeTab={1} billing={2} activeAccountTab={0} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/account/myProfile/contractAccount"
          exact
          element={
            <ProtectedRoute isAuthenticated={_props.isAuthenticated}>
              <Landing activeTab={1} billing={2} activeAccountTab={1} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/account/billing/invoice"
          element={
            <ProtectedRoute
              isAuthenticated={_props.isAuthenticated && (_props.viewInvoicesPermission || _props.managePaymentsPermission)}
              isPermitted={_props.viewInvoicesPermission || _props.managePaymentsPermission}
            >
              <Landing activeTab={1} billing={0} activePaymentTab={0} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/support/cases/caseList"
          element={
            <ProtectedRoute
              isAuthenticated={_props.isAuthenticated && (_props.viewallotherCasesPermission || _props.viewFinancialCasesPermission)}
              isPermitted={_props.viewallotherCasesPermission || _props.viewFinancialCasesPermission}
            >
              <Landing activeTab={1} cases={1} viewDetail={0} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/support/cases/viewCaseDetails/:caseId"
          element={
            <ProtectedRoute
              isAuthenticated={_props.isAuthenticated && (_props.viewallotherCasesPermission || _props.viewFinancialCasesPermission)}
              isPermitted={_props.viewallotherCasesPermission || _props.viewFinancialCasesPermission}
            >
              <Landing activeTab={1} cases={1} viewDetail={1} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/account/myContract"
          element={
            <ProtectedRoute
              isAuthenticated={_props.isAuthenticated && _props.manageyourcontractandservicesPermission}
              isPermitted={_props.manageyourcontractandservicesPermission}
            >
              <Landing activeTab={1} myContract={3} />
            </ProtectedRoute>
          }
        />
        {/* Provide access -> user other than government account and user who belongs to USA region*/}
        <Route
          path="/account/technicianAppointments"
          element={
            <ProtectedRoute
              isAuthenticated={_props.isAuthenticated && technicianAppointmentValidAccess}
              isPermitted={_props.isAuthenticated ? technicianAppointmentValidAccess : true}
            >
              {/* transferRemoveDevice = 0 refers to technician appointments list page */}
              <Landing activeTab={1} technicianAppointments={4} transferRemoveDevice={0} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/account/technicianAppointments/transferDevice"
          element={
            <ProtectedRoute
              isAuthenticated={_props.isAuthenticated && technicianAppointmentValidAccess}
              isPermitted={_props.isAuthenticated ? technicianAppointmentValidAccess : true}
            >
              {/* transferRemoveDevice = 1 refers to Transfer device request */}
              <Landing activeTab={1} technicianAppointments={4} transferRemoveDevice={1} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/account/technicianAppointments/removeDevice"
          element={
            <ProtectedRoute
              isAuthenticated={_props.isAuthenticated && technicianAppointmentValidAccess}
              isPermitted={_props.isAuthenticated ? technicianAppointmentValidAccess : true}
            >
              {/* transferRemoveDevice = 2 refers to Remove device request */}
              <Landing activeTab={1} technicianAppointments={4} transferRemoveDevice={2} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/account/technicianAppointments/viewAppointmentDetails/:appointmentId"
          element={
            <ProtectedRoute
              isAuthenticated={_props.isAuthenticated && technicianAppointmentValidAccess}
              isPermitted={_props.isAuthenticated ? technicianAppointmentValidAccess : true}
            >
              <Landing activeTab={1} technicianAppointments={4} viewAppointmentDetails={1} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/account/technicianAppointments/reschedule/:appointmentId"
          element={
            <ProtectedRoute
              isAuthenticated={_props.isAuthenticated && technicianAppointmentValidAccess}
              isPermitted={_props.isAuthenticated ? technicianAppointmentValidAccess : true}
            >
              <Landing activeTab={1} technicianAppointments={4} viewAppointmentDetails={2} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/login"
          element={
            <ProtectedRoute isAuthenticated={_props.customerPortalPermission} isPermitted={_props.customerPortalPermission}>
              <SecondLayerAuth title={REDBALL_INACTIVE_ACCOUNT_CONSTANTS.SELECT_CONTRACT_TITLE} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sessionExpired"
          element={
            <ProtectedRoute sessionExpired={true}>
              <Static title="Customer Portal - Session expired" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/revealSessionExpired"
          element={
            <ProtectedRoute revealSessionExpired={true}>
              <RevealSessionExpiredPage title="Customer Portal - Reveal session expired" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/logout"
          element={
            <ProtectedRoute logout={true}>
              <LogoutPage title="Customer Portal - Log out" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/permissionError"
          element={
            <ProtectedRoute SomethingWentWrong={true}>
              <SomethingWentWrong title="Customer Portal - Something went wrong" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/accessDenied"
          element={
            <ProtectedRoute accessDenied={true}>
              <AccessDenied title="Customer Portal - Access denied" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/inactiveAccount"
          element={
            <ProtectedRoute inactiveAccount={true}>
              <InactiveAccount title={REDBALL_INACTIVE_ACCOUNT_CONSTANTS.INACTIVE_ACCOUNT_TITLE} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/failedToAccessAccount"
          element={
            <ProtectedRoute failedToAccessAccount={true}>
              <FailedToAccessAccount title="Customer Portal - Failed to access account" />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/metrics-dashboard" element={<ProtectedRoute
             isAuthenticated={_props.isAuthenticated} isPermitted={true}><MetricDashboardPage /></ProtectedRoute>} />
        <Route
          path="/account/billing/invoice/makepayment"
          element={
            <ProtectedRoute
              isAuthenticated={_props.isAuthenticated && (_props.viewInvoicesPermission || _props.managePaymentsPermission)}
              isPermitted={_props.viewInvoicesPermission || _props.managePaymentsPermission}
            >
              <Navigate to="/account/billing/invoice" state={{ makePayment: true }} />
            </ProtectedRoute>
          }
        />
        ,
        <Route
          path="/account/billing/invoice/managepayment"
          element={
            <ProtectedRoute
              isAuthenticated={_props.isAuthenticated && (_props.viewInvoicesPermission || _props.managePaymentsPermission)}
              isPermitted={_props.viewInvoicesPermission || _props.managePaymentsPermission}
            >
              <Navigate to="/account/billing/invoice" state={{ managePayment: true }} />
            </ProtectedRoute>
          }
        />
      </Routes>
    </HashRouter>
  );
}
export default connect((state) => {
  return {
    isAuthenticated: state.ACCOUNT.account_id != "",
    account_id: state.ACCOUNT.account_id,
    customerPortalPermission: state.ACCOUNT.customerPortalPermission,
    accountProfilePermission: state.ACCOUNT.accountProfilePermission,
    viewInvoicesPermission: state.ACCOUNT.viewInvoicesPermission,
    managePaymentsPermission: state.ACCOUNT.managePaymentsPermission,
    viewFinancialCasesPermission: state.ACCOUNT.viewFinancialCasesPermission,
    viewallotherCasesPermission: state.ACCOUNT.viewallotherCasesPermission,
    manageyourcontractandservicesPermission: state.ACCOUNT.manageyourcontractandservicesPermission,
    activeCookie: state.ACCOUNT.activeCookie,
    contractAccountCountry: state.ACCOUNT.contractAccountCountry,
    vztSegment: state.ACCOUNT.vztSegment || "",
    brands: state.ACCOUNT.brands || "",
    userType: state.ACCOUNT.userType, 
    regionId: state.ACCOUNT.regionId, 
    technicianAppointmentValidAccess: state.ACCOUNT.technicianAppointmentValidAccess,
  };
})(Pages);
